import React, { Component } from "react";
import { invokeApig } from '../../libs/awsLib';

import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import { Glyphicon, Button, Col, Badge } from "react-bootstrap";
import '../../../node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css';

import UnitActions from './UnitActions';
import UnitDetail from './UnitDetail';

export default class ListUnit extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            units: [],
            refresh: false
        };
    }

    componentDidMount() {
    	this.updateTable();
    }

    componentWillReceiveProps(props) {
    	if (props.update !== this.props.update) {
    		this.updateTable();
    	}
    }

    updateTable = async () => {
    	this.setState({ isLoading: true, units: [], lastId: null });
		this.units().then((response) => {
			this.setState({ ...response, units: response.Items, isLoading: false });
		}, (error) => {
			alert(error);
        	this.setState({ isLoading: false });
        });
    }

    units() {
        return invokeApig({
            path: "/unit/find",
            method: "POST",
            body: {
                "page": 0,
                "size": 10
            }
        });
    }
/*
    units(lastId) {
        return invokeApig({
            path: "/unit/find",
            method: "POST",
            body: lastId
        });
    }
   */ 
/*
    handleAlertSuccess = (message) => {
      this.props.onAlertSuccess(message);
      this.setState({ isLoading: true });
      this.componentDidMount();
    }
    handleAlertError = (message) => {
      this.props.onAlertError(message);
    }
*/
    setTableOption() {
    	if (this.state.isLoading) {
    	  return <div><Glyphicon glyph="refresh" className="spinning" />Cargando datos... por favor espere</div>;
	    } else {
	      return "No hay datos";
	    }
    }

    unitsFormatter = (cell, row) => {
        return(
            //<Link to={{ pathname:"/support/detail", state: row }}>{cell}</Link>
            <UnitDetail {...this.props} unitId={row.original.id} unitInternalNumber={row.original.internalNumber}/>  
        )
    }

    actionsFormatter = (cell, row) => {
        return(
            //<Link to={{ pathname:"/support/detail", state: row }}>{cell}</Link>
            <UnitActions {...this.props} unitId={row.original.id} onAlertSuccess={this.handleAlertSuccess} onAlertError={this.handleAlertError}/>
        )
    }

    handleMore = async () => {
    	this.setState({ isMoreLoading: true });
    	try {
        	let results = await this.units({ lastId: this.state.lastId });
        	var units = this.state.units.slice();
        	results.units = units.concat(results.units);
            this.setState({ ...results, isMoreLoading: false });
        } catch (e) {
        	alert(e);
        	this.setState({ isMoreLoading: false });
        }
    }

    render(){
        const selectRowProp = {
            mode: 'radio',
            bgColor: 'pink', // you should give a bgcolor, otherwise, you can't regonize which row has been selected
            hideSelectColumn: true,  // enable hide selection column.
            clickToSelect: true,  // you should enable clickToSelect, otherwise, you can't select column.
            onSelect: this.onRowSelect,
          };
          const tableOptions = {
              noDataText: this.setTableOption()
          };
          const data = this.state.units;
        return(
            <div>
                <Col sm={4} className="update">
                    <Button onClick={this.updateTable} className="btnRefresh">
                        <Glyphicon glyph="refresh" />
                    </Button>
                </Col>
                <Col sm={12} className="units">
                    <BootstrapTable data={ data } selectRow={ selectRowProp } options={tableOptions}>
                        <TableHeaderColumn dataField='internalNumber' dataSort={ true } /*dataFormat={ this.unitsFormatter }*/ isKey>Número Interno</TableHeaderColumn>
                        <TableHeaderColumn dataField='licensePlate' filter={ { type: 'TextFilter', delay: 10 } } >RUN</TableHeaderColumn>
                        <TableHeaderColumn dataField='status' filter={ { type: 'TextFilter', delay: 10 } }  dataSort={ true }>Nombre</TableHeaderColumn>
                        <TableHeaderColumn dataField='creationDate' filter={ { type: 'TextFilter', delay: 10 } } dataSort={ true }>Fecha de creación</TableHeaderColumn>
                        <TableHeaderColumn dataSort={ true } /*dataFormat={ this.actionsFormatter }*/>Acciones</TableHeaderColumn>
                    </BootstrapTable>
                    {
                        this.state.lastId && (this.state.isMoreLoading ? <div><Glyphicon glyph="refresh" className="spinning" />Cargando más vehículos...</div> : <div><Button onClick={this.handleMore} className="loadMore">Cargar más...</Button></div>)
                    }
                </Col>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/unit/ListUnit.js